import { Pool } from "../../Utils/Collections/Pool";
import { PwuEntity } from "./PwuEntity";
import { NodeList } from "../../Utils/Collections/NodeList";
import { ePwuType, PwuType } from "./PwuType";
import { eAtlas_0, eGameAPI, eSfxSprite, Game } from "../../Game";
import { Node } from "../../Utils/Collections/Node";
import { Player } from "../Game World/Player/Player";
import { eMisstionType } from "../Gamee Missions/MissionType";
import { SoundManager } from "../../Utils/SoundManager";



export class PwuManager {
    static readonly HUD_ICON_X = 60;
    static readonly HUD_ICON_Y = -40;
    static readonly HUD_ICON_WIDTH = 110;

    private static _PWU_TYPES: PwuType[];

    static get INSTANCE(): PwuManager { return PwuManager._INSTANCE; }
    private static _INSTANCE: PwuManager;

    /**
     * Pool s volnymi entitami
     */
    private _freeEntityPool: Pool<PwuEntity>;

    /**
     * Seznam aktivnich entit
     */
    private _actEntities: NodeList<PwuEntity>;

    /**
     * Maska aktivnich powerupu
     */
    private _actMask: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        PwuManager._INSTANCE = this;

        if (!PwuManager._PWU_TYPES) {
            PwuManager._PWU_TYPES = [
                new PwuType(ePwuType.scoreMultiplier, 10 * 1000, "", this.actScoreMultiplier, this.deactScoreMultiplier)
            ];
        }

        this._freeEntityPool = new Pool<PwuEntity>(PwuEntity, 1, true);
        this._actEntities = new NodeList<PwuEntity>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._actEntities.forEach((pwu: PwuEntity) => {
            pwu.reset();
            this._freeEntityPool.returnItem(pwu);
        });

        this._actEntities.clear();
        this._actMask = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activatePwu(type: ePwuType): void {
        // Sfx
        SoundManager.playSound(Player.instance.entity, eSfxSprite.pwuActivation);

        let pwuEntity: PwuEntity;

        if ((this._actMask & (1 << type)) != 0) {
            // Najit entitu s powerupem a reaktivovat ho
            this._actEntities.every((pwu: PwuEntity): boolean => {
                if (pwu.type.type == type) {
                    (pwuEntity = pwu).reactivate();
                    return false;
                }

                return true;
            });
        }
        else {
            // Aktivovat powerupu
            pwuEntity = this._freeEntityPool.getItem();

            pwuEntity.activate(PwuManager._PWU_TYPES[type]);
            this._actEntities.add(pwuEntity);
            this._actMask |= (1 << type);
        }

        // Aplikovat powerup
        PwuManager._PWU_TYPES[type].actFnc.call(this, pwuEntity);
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci true, pokud je zadany typ powerupu aktivni
     * @param type 
     */
    //-------------------------------------------------------------------------
    isPwuActive(type: ePwuType): boolean {
        return (this._actMask & (1 << type)) != 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        this._actEntities.forEach((pwu: PwuEntity, node: Node<PwuEntity>) => {
            if (!pwu.update()) {
                pwu.type.deactFnc.call(this);
                this._actEntities.removeByNode(node);
                this._freeEntityPool.returnItem(pwu);
                this._actMask &= ~(1 << pwu.type.type);
            }
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private actScoreMultiplier(pwuEntity: PwuEntity): void {
        let score = Player.instance.score;
        let multiplier = ++score.multiplier;

        pwuEntity.showIcon(this._actEntities.size - 1, "pwu" + multiplier + "x");

        // Mise
        if (Game.API == eGameAPI.GAMEE)
            Game.missions.setMissionValue(eMisstionType.getMultiplier, multiplier)
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private deactScoreMultiplier(): void {
        Player.instance.score.multiplier = 1;
    }
}